<div
  class="grid grid-cols-1 grid-rows-5 h-full"
  [ngClass]="{
    'pt-16 md:pt-20 xl:pt-24': floatingTileData.topPadding,
    'pb-16 md:pb-20 xl:pb-24': floatingTileData.bottomPadding,
    'bg-ss-www-background': floatingTileData.bottomBackgroundColor === 'gray',
    'bg-black': floatingTileData.bottomBackgroundColor === 'black',
    'bg-white': floatingTileData.bottomBackgroundColor === 'white',
    '-mt-12 md:-mt-14':
      !floatingTileData.header &&
      floatingTileData.overlayAmount === 'little' &&
      floatingTileData.actuallyOverlay,
    '-mt-24 md:-mt-36':
      floatingTileData.header &&
      floatingTileData.overlayAmount === 'normal' &&
      floatingTileData.actuallyOverlay,
    '-mt-16 md:-mt-32':
      !floatingTileData.header &&
      floatingTileData.overlayAmount === 'normal' &&
      floatingTileData.actuallyOverlay,
    '-mt-44 md:-mt-60':
      floatingTileData.overlayAmount === 'extra' &&
      floatingTileData.actuallyOverlay,
    'pb-16 md:pb-24': !floatingTileData.actuallyOverlay,
  }"
>
  <div
    class="row-start-1 col-start-1 col-span-1"
    [ngClass]="{
      'bg-ss-www-background': floatingTileData.topBackgroundColor === 'gray',
      'bg-black': floatingTileData.topBackgroundColor === 'black',
      'bg-white': floatingTileData.topBackgroundColor === 'white',
      'bg-transparent': floatingTileData.topBackgroundColor === 'transparent',
      'row-span-2':
        floatingTileData.overlayAmount === 'little' &&
        floatingTileData.variant !== 'card',
      'row-span-1': floatingTileData.variant === 'card',
      'row-span-3': floatingTileData.overlayAmount === 'normal',
      'row-span-4': floatingTileData.overlayAmount === 'extra',
    }"
  ></div>
  <div
    class="col-start-1 col-span-1"
    [ngClass]="{
      'row-start-3 row-span-3':
        floatingTileData.overlayAmount === 'little' &&
        floatingTileData.variant !== 'card',
      'row-start-2 row-span-4': floatingTileData.variant === 'card',
      'row-start-4 row-span-2': floatingTileData.overlayAmount === 'normal',
      'row-start-5 row-span-1': floatingTileData.overlayAmount === 'extra',
    }"
  ></div>

  <div class="z-10 row-start-1 row-span-5 col-start-1 col-span-1">
    @if (floatingTileData.header) {
      <div
        class="text-center mb-0 md:mb-6"
        [innerHTML]="floatingTileData.header"
        [ssDirectus]="{
          collection: 'floatingTiles',
          item: floatingTileData.id,
          fields: ['header'],
        }"
      ></div>
    }

    <!--If tilesPerRow specified, use grid. otherwise use flex-->
    <div
      class="gap-4 md:gap-5 px-8 md:px-0"
      [ssDirectus]="{
        collection: 'floatingTiles',
        item: floatingTileData.id,
        fields: ['tiles'],
      }"
      [ngClass]="{
        'flex flex-col md:flex-row md:flex-wrap md:justify-center ':
          !floatingTileData.tilesPerRow,
        'grid grid-cols-1 md:[grid-template-columns:repeat(2,40%)] justify-center':
          floatingTileData.tilesPerRow,
        'lg:[grid-template-columns:repeat(2,25%)] lg:gap-x-[12%]':
          floatingTileData.tilesPerRow === 2,
        'lg:[grid-template-columns:repeat(3,20%)] lg:gap-x-[8%]':
          floatingTileData.tilesPerRow === 3,
        'lg:[grid-template-columns:repeat(6,11.3%)]':
          floatingTileData.tilesPerRow === 6,
      }"
    >
      <!--if no tilesPerRow, hide on non lg screens to center tiles-->
      @if (!floatingTileData.tilesPerRow) {
        <div
          [ngClass]="{
            'hidden lg:block lg:flex-1': hasAnyProductName(),
            'flex-1 block': !hasAnyProductName(),
          }"
        ></div>
      }

      @if (floatingTileData.variant === 'transparent') {
        <ng-container>
          @for (tile of floatingTileData.tiles; track $index) {
            @if (tile.shopLink) {
              <a
                [href]="tile.shopLink"
                class="w-full"
                [ssDirectus]="{
                  collection: 'floatingItem',
                  item: tile.id,
                  fields: [
                    'backgroundImage',
                    'shopLink',
                    'productName',
                    'text',
                  ],
                }"
                [ngClass]="{
                  'flex flex-1 grow shrink-0 lg:max-w-[18.75rem]':
                    !floatingTileData.tilesPerRow && !tile.productName,
                  'md:w-[40%] md:justify-center lg:flex lg:flex-1 lg:grow lg:shrink-0 lg:max-w-[18.75rem]':
                    !floatingTileData.tilesPerRow && tile.productName,
                  'min-h-[16rem]': tile.productName,
                }"
              >
                <button
                  class="border-2 border-ss-gold rounded-xl w-full h-full overflow-hidden"
                >
                  <div class="w-full aspect-square">
                    <ss-www-image-with-loader
                      class="w-full h-full"
                      [fileDetail]="tile.backgroundImage"
                      desktopImageSize="half"
                    />
                  </div>

                  @if (tile.productName) {
                    <div class="px-8 py-5 lg:px-3">
                      <h5
                        class="text-lg lg:text-[0.9rem] lg:leading-[1rem] text-center font-semibold text-ss-gold leading-none"
                      >
                        {{ tile.productName }}
                      </h5>
                    </div>
                  }
                </button>
              </a>
            } @else {
              <div
                class="border-2 border-ss-gold rounded-xl flex flex-col justify-end px-4 py-4 md:px-8 md:py-6 grow shrink-0 bg-cover bg-center"
                [ssDirectus]="{
                  collection: 'floatingItem',
                  item: tile.id,
                  fields: ['backgroundImage', 'buttons'],
                }"
                [ngClass]="{
                  'aspect-square basis-1/5': tile.backgroundImage && !tile.text,
                  'aspect-[6/4] basis-1/3': tile.backgroundImage && tile.text,
                  'bg-gradient-to-t from-black via-black/95 to-black/60 basis-1/5':
                    !tile.backgroundImage,
                  'lg:max-w-[18.75rem]': !tile.backgroundImage,
                }"
                [ngStyle]="{
                  'background-image':
                    tile.backgroundImage && tile.text
                      ? 'linear-gradient(180deg, rgba(0, 0, 0, 0) 38%, rgba(0, 0, 0, 0.85) 82%), url(' +
                        getImageUrl(tile) +
                        ')'
                      : tile.backgroundImage
                        ? 'url(' + getImageUrl(tile) + ')'
                        : '',
                }"
              >
                @if (tile.text) {
                  <div
                    [innerHTML]="tile.text"
                    class="flex flex-col gap-2 text-center [&>h3]:lg:text-2xl"
                    [ssDirectus]="{
                      collection: 'floatingItem',
                      item: tile.id,
                      fields: ['text'],
                    }"
                  ></div>
                }

                @if (tile.buttons.length) {
                  <div
                    class="flex items-center justify-center gap-4"
                    [ngClass]="hasBackgroundImages ? 'mt-2' : 'mt-3 md:mt-4'"
                  >
                    @for (
                      buttonLink of tile.buttons;
                      track trackByButtons($index, buttonLink)
                    ) {
                      <ss-building-block-button-link
                        [buttonLink]="buttonLink.item"
                      ></ss-building-block-button-link>
                    }
                  </div>
                }
              </div>
            }
          }
        </ng-container>
      } @else {
        <ng-template>
          @for (tile of floatingTileData.tiles; track trackByFn($index, tile)) {
            <div
              class="flex flex-col md:basis-[39%] md:grow-0 rounded-2xl overflow-hidden aspect-[3/4] md:aspect-[7/6]"
            >
              @if (tile.backgroundImage) {
                <ss-www-image-with-loader
                  class="basis-1/3 md:basis-[55%]"
                  desktopImageSize="half"
                  [fileDetail]="tile.backgroundImage"
                ></ss-www-image-with-loader>
              }
              <div
                class="bg-ss-brown text-left basis-2/3 md:basis-[45%] p-6"
                [innerHTML]="tile.text"
                [ssDirectus]="{
                  collection: 'floatingItem',
                  item: tile.id,
                  fields: ['text'],
                }"
              ></div>
            </div>
          }
        </ng-template>
      }
      <!--if no tilesPerRow, hide on non lg screens to center tiles-->
      @if (!floatingTileData.tilesPerRow) {
        <div
          [ngClass]="{
            'hidden lg:block lg:flex-1': hasAnyProductName(),
            'flex-1 block': !hasAnyProductName(),
          }"
        ></div>
      }
    </div>
  </div>
  @if (floatingTileData.extraBottomPad) {
    <div class="h-36 md:h-44"></div>
  }
</div>
